// src/components/SEO.js
import React from "react";
import { Title, Meta, Link, HeadProvider } from "react-head";

// Default values (used if props are missing)
const DEFAULTS = {
  title: "Joujo Safaris - Explore Kenya & Beyond",
  description:
    "Join Joujo Safaris for unforgettable safari adventures across Kenya, Tanzania, Zanzibar and beyond. Experience wildlife, culture and nature at its best.",
  keywords: "Kenya safari, Masai Mara tours, Zanzibar trips, Africa travel, Joujo Safaris",
  url: "https://joujosafaris.com/",
  image: "https://joujosafaris.com/assets/default-safari.jpg",
  twitterHandle: "@joujosafaris",
};

const SEO = ({
  title = DEFAULTS.title,
  description = DEFAULTS.description,
  keywords = DEFAULTS.keywords,
  url = DEFAULTS.url,
  image = DEFAULTS.image,
  type = "website",
  twitterHandle = DEFAULTS.twitterHandle,
  schema,
}) => {
  return (
    <>
    <HeadProvider>
      {/* Standard Meta */}
      <Title>{title}</Title>
      <Meta name="description" content={description} />
      {keywords && <Meta name="keywords" content={keywords} />}
      <Link rel="canonical" href={url} />

      {/* Open Graph */}
      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={description} />
      <Meta property="og:type" content={type} />
      <Meta property="og:url" content={url} />
      {image && <Meta property="og:image" content={image} />}

      {/* Twitter Card */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content={title} />
      <Meta name="twitter:description" content={description} />
      {image && <Meta name="twitter:image" content={image} />}
      {twitterHandle && <Meta name="twitter:site" content={twitterHandle} />}

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
      </HeadProvider>
    </>
  );
};

export default SEO;
